import { render } from "./WalletVerify.vue?vue&type=template&id=d67e6a64"
import script from "./WalletVerify.vue?vue&type=script&lang=js"
export * from "./WalletVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__